export class InvitacionVisitaDTO {
    constructor(
        public rutContratistas: number[],
        public fechaVigencia: string,
        public comentario: string
    ) {
        this.rutContratistas = rutContratistas;
        this.fechaVigencia = fechaVigencia;
        this.comentario = comentario;
    }
}
